var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "User Circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 1",
    d: "M33.9393 39.0094C33.4513 35.0585 30.0828 32 26 32H22C17.9172 32 14.5487 35.0585 14.0607 39.0094M33.9393 39.0094C38.7973 35.7859 42 30.267 42 24C42 14.0589 33.9411 6 24 6C14.0589 6 6 14.0589 6 24C6 30.267 9.20273 35.7859 14.0607 39.0094M33.9393 39.0094C31.0912 40.8992 27.6741 42 24 42C20.3259 42 16.9088 40.8992 14.0607 39.0094M30 20C30 23.3137 27.3137 26 24 26C20.6863 26 18 23.3137 18 20C18 16.6863 20.6863 14 24 14C27.3137 14 30 16.6863 30 20Z",
    stroke: "#E52823",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserCircle);
export default __webpack_public_path__ + "static/media/user-circle.e24eb96c0bdb60d72d0e795361405e85.svg";
export { ForwardRef as ReactComponent };